import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", sm: "column", md: "row" },
  borderRadius: 2,
  gap: "24px",
  px: { xs: 1, sm: 2, md: 10 },
};

export const titleBoxStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: { xs: "center", sm: "center", md: "flex-start" },
  justifyContent: "center",
};

export const titleStyle: SxProps<Theme> = (theme) => ({
  fontSize: "20px",
  fontWeight: 600,
  color: theme.palette.quizPopap.quizText,
});

export const progressContainerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  mx: { xs: "0", sm: "0", md: "40px" },
  justifyContent: "center",
};

export const progressRowStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  gap: "5px",
};

export const progressLabelStyle: SxProps<Theme> = {
  color: "#06B6D4",
  fontSize: "16px",
  fontWeight: 600,
};

export const linearProgressStyle: SxProps<Theme> = (theme) => ({
  height: 10,
  borderRadius: 4,
  backgroundColor: theme.palette.quizPopap.quizLineBg,
  "& .MuiLinearProgress-bar": {
    background: "linear-gradient(90deg, #8957CF 0%, #28C9DC 100%)",
  },
});
